import { AddAssetDropdown, Button, DashboardTopBar } from "shared";
import { AssetCategorySlug } from "enums/AssetCategoryEnum";
import { SVG_ENUM } from "enums";
import { isDesktop } from "utils";
import { openMeetingBooking } from "../utils";
import { CompaniesTabsType } from "../types";

interface InvestmentsTopBarProps {
  tab: CompaniesTabsType["tab"];
  isAdmin: boolean;
  isCompanyInfoOpenModal: boolean;
  onAssetSelect: (slug: string) => void;
  isSuccessorView?: boolean;
}

const InvestmentsTopBar = ({
  tab,
  isAdmin,
  isCompanyInfoOpenModal,
  onAssetSelect,
  isSuccessorView = false,
}: InvestmentsTopBarProps) => {
  return (
    <DashboardTopBar>
      <h1 className="dashboard__header">
        {isAdmin ? "Aktywa" : "Moje aktywa"}
      </h1>
      <div className="investmentsPage__buttons">
        {tab === "my" ? (
          <Button
            onClick={openMeetingBooking}
            className="dashboard__top-button button--rounded button--hide-on-mobile button--transparent investmentsPage__meeting"
            label="Umów spotkanie"
            svg={SVG_ENUM.CALENDAR}
          />
        ) : null}

        {isDesktop() &&
          !isSuccessorView &&
          (tab === "my" || (isAdmin && tab === "reliance")) &&
          !isCompanyInfoOpenModal && (
            <div
              className={
                isAdmin
                  ? "investmentsTopBar__addAsset investmentsTopBar__addAsset--admin"
                  : "investmentsTopBar__addAsset"
              }
            >
              <AddAssetDropdown
                onSelect={(slug: AssetCategorySlug) => {
                  onAssetSelect(slug);
                }}
              />
            </div>
          )}
      </div>
    </DashboardTopBar>
  );
};

export default InvestmentsTopBar;
